import { getColor, styled, keyframes, belowBreakpoint, belowBreakpointOrEqual } from "imaginarity-react-ui";



export class TabsBarSC {

    public static flyToRight = keyframes`
    from { opacity:1; transform: translateX(-100%); }
    to { opacity:1; transform: translateX(0); }
`;
    public static flyToLeft = keyframes`
    from { opacity:1; transform: translateX(100%); }
    to { opacity:1; transform: translateX(0); }
`;
    public static flyToBottom = keyframes`
    from { opacity:0; transform: translateY(100%) scaleY(0); }
    to { opacity:1; transform: translateX(0) scaleY(1);}
`;
    public static Container = styled.div<{ tabsLength: number, shadowed?: boolean }>`
    padding-top: ${p => p.shadowed ? 5 : 0}px;
    width: ${p => belowBreakpoint(p, "tablet") ? "calc(100% - 10px)" : "100%"};
    display: grid;
    grid-template-columns: ${p => belowBreakpoint(p, "tablet") ? "max-content  1fr" : `repeat(${p.tabsLength}, max-content) 1fr`} ;
    background: ${p => getColor(p, p.theme?.tabsBar?.tabsBarBackgroundColor ?? "@veryLightGrey")};
    transition: all 0.2s ease-out;
    margin-left: ${p => belowBreakpoint(p, "tablet") ? 5 : 0}px;
    margin-right: ${p => belowBreakpoint(p, "tablet") ? 5 : 0}px;
    button>div{margin: 0;}
`;
    public static Tab = styled.div<{ active?: boolean, checked?: boolean, activeBold?: boolean, shadowed?: boolean }>`
    position: relative;
    line-height: 40px;
    padding: 0 15px;
    user-select: none;
    font-weight: ${p => (p.activeBold && p.active) ? "bolder" : "normal"};
    cursor: ${p => p.active === true ? "default" : "pointer"};
    color: ${p => p.active === true ? getColor(p, p.theme?.tabsBar?.fontColorActive ?? "@darkerGrey") : getColor(p, p.theme?.tabsBar?.fontColor ?? "@lightGrey")};
    background: ${p => p.active === true ? getColor(p, p.theme?.tabsBar?.tabBackgroundActive ?? "@mainBackground") : getColor(p, p.theme?.tabsBar?.tabBackground ?? "@mainBackground")};
    border-bottom: 1px solid ${p => p.active ? getColor(p, p.theme?.tabsBar?.tabBackgroundActive ?? "@mainBackground") : getColor(p, p.theme?.tabsBar?.tabsBorderColor ?? "@middleLightGrey")};
    border-top: ${p => p.active ? 1 : 0}px solid ${p => p.active ? getColor(p, p.theme?.tabsBar?.tabsBorderColor ?? "@middleLightGrey") : "transparent"};
    border-left: ${p => p.active ? 1 : 0}px solid ${p => p.active ? getColor(p, p.theme?.tabsBar?.tabsBorderColor ?? "@middleLightGrey") : "transparent"};
    border-right: ${p => p.active ? 1 : 0}px solid ${p => p.active ? getColor(p, p.theme?.tabsBar?.tabsBorderColor ?? "@middleLightGrey") : "transparent"};
    box-shadow: ${p => p.active && p.shadowed ? `0 -3px 4px -5px ${getColor(p, "@accentBlack")}` : "none"};
    font-size: ${p => belowBreakpointOrEqual(p, "tablet") ? 0.9 : 1}em;
    transition: background 0.2s ease-out;
        z-index: 8;
    &:hover{
        color: ${p => p.checked === true ? getColor(p, p.theme.colors.accentGreen) : p.active === true ? getColor(p, p.theme?.tabsBar?.fontColorActive ?? "@darkerGrey") : getColor(p, p.theme?.tabsBar?.fontColorHover ?? "@accentBlack")};
        background: ${p => p.active ? undefined : "rgba(0,0,0,0.05)"};
    }
    .icon-only-title {
        display: none;
    }
    &:hover .icon-only-title {
        display: inline;
    }
`;
    public static TabsContainer = styled.div`
    min-width: 0;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    background: linear-gradient(to bottom, transparent calc(100% - 1px), ${p => getColor(p, p.theme?.tabsBar?.tabsBorderColor ?? "@middleLightGrey")} 1px);
`;
    public static Rest = styled.div`
    border-bottom: 1px solid ${p => getColor(p, p.theme?.tabsBar?.tabsBorderColor ?? "@middleLightGrey")};
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    button>div{margin: 0;}
`;
    public static Underline = styled.div<{ hasIcon: boolean, direction: "bottom" | "right" | "left", checked?: boolean, hasMsg?: boolean }>`
    position: absolute;
    left: ${p => p.hasIcon ? 41 : 13}px;
    right: 13px;
    height: 3px;
    background: ${p => p.hasMsg === true ? getColor(p, "@accentRed") : p.checked === true ? getColor(p, p.theme.colors.accentGreen) : getColor(p, p.theme?.tabsBar?.underlineBarColor ?? "@accentOrange")};
    top: 36px;
	animation: ${p => p.theme?.tabsBar?.underlineBarAnimated ? (p.direction === "bottom" ? this.flyToBottom : p.direction === "right" ? this.flyToRight : this.flyToLeft) : "none"} 0.7s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;
    `;
}